// extracted by mini-css-extract-plugin
module.exports = {"text":"Share_text__IlERk","heading":"Share_heading__VxC1k","share_link":"Share_share_link___QSPi","tooltip":"Share_tooltip__YjSOd"};